import { BACKEND_URL } from "@/lib/api";

export const photoSrc = (url) => (url?.startsWith("/") ? `${BACKEND_URL}${url}` : url || null);

const initials = (name = "") => name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";

export const Avatar = ({ url, name, size = 40, testId }) => {
  const src = photoSrc(url);
  const style = { width: size, height: size, fontSize: size * 0.4 };
  return src ? (
    <img src={src} alt={name ? `${name}'s photo` : "Profile photo"} referrerPolicy="no-referrer" style={style}
      className="rounded-full object-cover shrink-0 bg-mm-soft" data-testid={testId} />
  ) : (
    <div style={style} className="rounded-full mm-gradient text-white font-bold flex items-center justify-center shrink-0" data-testid={testId}>
      {initials(name)}
    </div>
  );
};
